import type { UserProfile } from "@/services/authService";
import { Role } from "@/types/user";
import { hasAnyRole, hasFrontdeskBlockPermission } from "@/utils/accessControl";

export type AnalyticsAccess = "admin" | "frontDesk" | null;

const SUPER_ADMIN_ROLE = "SUPER_ADMIN";
const ADMIN_ANALYTICS_ROLES: readonly string[] = [
  SUPER_ADMIN_ROLE,
  Role.TENANT_ADMIN,
];
const FRONT_DESK_ANALYTICS_ROLES: readonly string[] = [
  Role.HOTEL_ADMIN,
  Role.FRONT_DESK,
  Role.STAFF,
];

/**
 * Which analytics dashboard a user may open, or null when none.
 * `role` carries a custom role's display name, so the base role is read
 * through `hasAnyRole`; a custom Front Desk role additionally needs the
 * `frontdesk_management` block, the same permission the analytics API checks
 * and the same predicate the sidebar uses for `/analytics`.
 */
export function getAnalyticsAccess(
  userProfile: UserProfile | null,
): AnalyticsAccess {
  if (!userProfile) return null;
  if (hasAnyRole(userProfile, ADMIN_ANALYTICS_ROLES)) return "admin";
  if (
    hasAnyRole(userProfile, FRONT_DESK_ANALYTICS_ROLES) &&
    hasFrontdeskBlockPermission(userProfile, "frontdesk_management")
  ) {
    return "frontDesk";
  }
  return null;
}
